import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './SourcingAndPricingUploadFile.css';

const SOURCING_AND_PRICING_ROOT =
  process.env.REACT_APP_SNP_START_PATH || '/sourcing-pricing';

function SourcingAndPricingUploadFile({
  currentPath,
  userId,
  onFileUploaded,
}) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={SOURCING_AND_PRICING_ROOT}
      sessionPrefix="sourcing_and_pricing_file"
    />
  );
}

SourcingAndPricingUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default SourcingAndPricingUploadFile;
